import { SilentApiRequestError } from "../network/apiRequest";

export default function silentHandleApiRequestErrors(error) {
  if (!(error instanceof SilentApiRequestError)) {
    throw error;
  }
}
